import React from 'react';
import {
	BrowserRouter as Router,
	Redirect,
} from 'react-router-dom';
import qs from 'qs';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Enquiries from '../services/Enquiries';
import Button from '@material-ui/core/Button';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import CustomSnackbar from '../components/Containers/CustomSnackbar';

const styles = theme => ({
	container: {
		display: "flex",
		width: "100%",
		height: "100vh",
	},
	loginArea: {
		width: "80%",
		margin: "auto",
	},
	loginSymbol: {
		width: "50px",
		margin: "auto",
		display: "flex",
	},
	loginTitle: {
		fontFamily: "Saira,sans-serif",
		fontWeight: 600,
		color: "#32618c",
		fontSize: "32px",
		lineHeight: "1.2",
		width: "100%",
		fontSize: "28px",
		margin: "10px 0 10px 0",
	},
	loginInput: {
		width: "100%",
	},
	loginButton: {
		margin: "0 auto",
		display: "flex",
		marginTop: "16px",
	},
	forgotPassword: {
		cursor: "pointer",
		color: theme.palette.primary.main,
		fontFamily: "Inter,sans-serif",
		textDecoration: "none",
		fontSize: "16px",
	},
	progress: {
		top: `calc(50vh - 100px)`,
		margin:'auto',
	},
	loadingArea: {
		height: "100vh",
		display: "flex",
		alignItems: "center",
		textAlign: "center",
	},
	matchMessage: {
		color: theme.palette.primary.main,
		fontFamily: "Inter,sans-serif",
		textDecoration: "none",
		fontSize: "16px",
	}
});

class EscrowLanding extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			name: '',
			company_name: '',
			phone_number: '',
			email_address: '',
			name_valid: true,
			company_name_valid: true,
			phone_or_email_valid: true,
			ready_to_submit: false,
			escrow_token: '',
			snackbar: {
				open: false
			},
		};
	}

	handleChange = (event) => {
		var parent = this;
		var stateObject = function () {
			let returnObj = {};
			returnObj[this.target.id] = this.target.value;
			return returnObj;
		}.bind(event)();
		this.setState(stateObject, () => {
			var stateAdditions = {}
			if (this.state.name == null || this.state.name === "") {
				stateAdditions.name_valid = false;
			} else {
				stateAdditions.name_valid = true;
			}
			if (this.state.company_name == null || this.state.company_name === "") {
				stateAdditions.company_name_valid = false;
			} else {
				stateAdditions.company_name_valid = true;
			}
			if ((this.state.email_address == null || this.state.email_address === "") &&
					(this.state.phone_number == null || this.state.phone_number === "")) {
				stateAdditions.phone_or_email_valid = false;
			} else {
				stateAdditions.phone_or_email_valid = true;
			}
			stateAdditions.ready_to_submit = stateAdditions.name_valid && stateAdditions.company_name_valid && stateAdditions.phone_or_email_valid;
			this.setState(stateAdditions);
		});
	}

	sendEnquiry = () => {
		let token = qs.parse(this.props.location.search)["?escrow_token"];
		let body = {
			name: this.state.name,
			company_name: this.state.company_name,
			email_address: this.state.email_address,
			phone_number: this.state.phone_number,
			escrow_token: token
		};
		Enquiries.createEscrowDeviceEnquiry(body).then( () => {
			this.openSnackbar("Your enquiry has been sent!", true);
		}).catch( (error) => {
			this.openSnackbar(error, false);
		});
	}

	openSnackbar = (message, result) => {
		result ? result = "success" : result = "error";
		this.setState( {snackbar: {
			message: message,
			result: result,
			open: true,
		}});
	}

	closeSnackbar = () => {
		this.setState( {snackbar: {
			message: "",
			open: false,
			result: this.state.snackbar.result
		}});
	}

	render() {
		const { classes } = this.props;
		if (this.state.invalidToken === null) {
			return (
				<div className={classes.loadingArea}>
					<CircularProgress className={classes.progress} color="primary" />
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.snackbar.open}
						autoHideDuration={4000}
						onClose={this.closeSnackbar}
					>
						<CustomSnackbar
							onClose={this.closeSnackbar}
							variant={this.state.snackbar.result}
							message={this.state.snackbar.message}
						/>
					</Snackbar>
				</div>
			);
		} else {
			return (
				<div className={classes.container}>
					<div className={classes.loginArea}>
						<img className={classes.loginSymbol} src={require('../images/ms_icon_new.png')} />
						<h5 className={classes.loginTitle}>Welcome to EdgeIQ!</h5>
						<div className={classes.matchMessage}>To get started with your free trial, fill out the information below and an EdgeIQ representative will contact you:</div>
							<TextField
								id="name"
								label="Name*"
								className={classes.loginInput}
								margin="normal"
								variant="outlined"
								value={this.state.name}
								onChange={this.handleChange}
							/>
							<TextField
								id="company_name"
								label="Company Name*"
								className={classes.loginInput}
								margin="normal"
								variant="outlined"
								value={this.state.company_name}
								onChange={this.handleChange}
							/>
							<TextField
								id="email_address"
								label="Email Address"
								className={classes.loginInput}
								margin="normal"
								variant="outlined"
								value={this.state.email_address}
								onChange={this.handleChange}
							/>
							<TextField
								id="phone_number"
								label="Phone Number"
								className={classes.loginInput}
								margin="normal"
								variant="outlined"
								value={this.state.phone_number}
								onChange={this.handleChange}
							/>
							<Button onClick={this.sendEnquiry}
								className={classes.loginButton}
								color="primary"
								variant="contained"
								disabled={!this.state.ready_to_submit}
							>
								Submit
							</Button>
					</div>
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.snackbar.open}
						autoHideDuration={4000}
						onClose={this.closeSnackbar}
					>
						<CustomSnackbar
							onClose={this.closeSnackbar}
							variant={this.state.snackbar.result}
							message={this.state.snackbar.message}
						/>
					</Snackbar>
				</div>
			)
		}
	}
}

export default withStyles(styles)(withTheme()(EscrowLanding));

